import { LoginComponent } from '../login/login.component';
import { AuthenticationService } from "../../services/authentication.service";
import { Component, OnInit } from "@angular/core";
import { DialogService } from "../../services/dialog.service";
import { RegisterComponent } from '../register/register.component';
import { Router } from "@angular/router";
import { User } from "../../models/user";

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {

    currentUser: User;
    userRole: String = "";

    constructor(private dialogService: DialogService,
        public authService: AuthenticationService,
        private router: Router) {
        this.authService.loggedInUser$.subscribe(x => {
            this.currentUser = x;
            if (this.currentUser)
                this.userRole = this.currentUser['authorities'][0]['authority'];
        });

    }

    ngOnInit(): void {
        const mode = localStorage.getItem('mode');
        const htmlElement = document.getElementsByTagName('html')[0];
        if (mode === 'dark-mode'){
            htmlElement.classList.add('dark-mode');
            htmlElement.classList.remove('light-mode');
            setTimeout(() => {
                this.changeTheme();
            }, 1);
        }
    }

    loginDialog() {
        this.dialogService.openDialog(LoginComponent);
    }

    registerDialog() {
        this.dialogService.openDialog(RegisterComponent);
    }

    logout() {
        this.authService.logout().then(() => this.authService.setLoggedUser(null));
        this.router.navigateByUrl("home").then();
    }
    checkIfUserLogged(){
        if (this.currentUser != null && this.userRole === 'ROLE_USER') {
            this.router.navigateByUrl("CV").then();
        }
        else {
            this.loginDialog();
        }
    }
    changeTheme() {
        const icon = document.getElementById('iconTheme');
        const htmlElement = document.getElementsByTagName('html')[0];
        const logo = document.getElementById('logo');
        const best = document.getElementById('best');
        if (icon?.textContent?.trim() === 'light_mode'){
            icon.textContent = 'dark_mode';
            htmlElement.classList.add('dark-mode');
            htmlElement.classList.remove('light-mode');
            logo.setAttribute('src', '../../../assets/Job_Fair_Logo-02.svg');
            best.setAttribute('src', '../../../assets/best-logo-light.svg');
            localStorage.setItem('mode', 'dark-mode');
        }
        else {
            icon.textContent = 'light_mode';
            htmlElement.classList.add('light-mode');
            htmlElement.classList.remove('dark-mode');
            logo.setAttribute('src', '../../../assets/Job_Fair_Logo.svg');
            best.setAttribute('src', '../../../assets/best-logo.svg');
            localStorage.setItem('mode', 'light-mode');
        }
    }
}
